// Import Actions
import { SET_ANSWERS } from './AnswerActions';

// Initial State
export const initialState = {
    data: [],
};

// Think to update reducers.js

const AnswerReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_ANSWERS:
            return {
                ...state,
                data: state.data
                    .filter(existingAnswer => !action.answers.find(answer => (answer._id === existingAnswer._id) || (answer.question === existingAnswer.question && answer.applicant === existingAnswer.applicant)))
                    .concat(action.answers),
            };

        default:
            return state;
    }
};

export default AnswerReducer;
